/**
 * Calendar constants extracted from EventListModule (PR3, owned by PR3 per
 * _CROSS_FILE_FINDINGS). Byte-identical moves — no behavior change.
 */

/** Matches a date-only string (YYYY-MM-DD). */
export const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Bounds of the Day/Week time grid, as hour-of-day offsets. The grid renders
 * one row per hour in `[DAY_GRID_START_HOUR, DAY_GRID_END_HOUR)`.
 *
 * #3534/#3585: the grid runs the full day through to midnight (END_HOUR=24), so
 * late-evening events (10 PM, 11 PM) stay visible. These are the SINGLE source
 * of truth — `DayView`, `WeekView`, and `useCalendarNavigation`'s scroll-to-8 AM
 * target all derive from `DAY_GRID_VISIBLE_HOURS` so the rendered grid and the
 * scroll math can never drift (the previous hardcoded `VISIBLE_HOURS = 22` in
 * the scroll effect overshot 8 AM once END_HOUR moved to 24).
 */
export const DAY_GRID_START_HOUR = 0;
export const DAY_GRID_END_HOUR = 24;
export const DAY_GRID_VISIBLE_HOURS = DAY_GRID_END_HOUR - DAY_GRID_START_HOUR;

// Generate time options in 15-minute intervals
export const TIME_OPTIONS = (() => {
  const options: { value: string; label: string }[] = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const value = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      const hour12 = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
      const ampm = hour < 12 ? 'AM' : 'PM';
      const label = `${hour12}:${minute.toString().padStart(2, '0')} ${ampm}`;
      options.push({ value, label });
    }
  }
  return options;
})();
